import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { Project } from '../../app/entities/project';
import { ProjectSettingsForm } from './components/project-settings-form';
import { DangerZone } from '../../features/projects/components/danger-zone';
import { Header } from './project.page';
import { uiStore } from '../../core/stores/ui-store';
import { ScreenContainer } from '../../features/projects/components/styled-project-components';

import styles from './project-settings.route.module.scss';
interface SettingsTabProps {
  project?: Project;
}

export const ProjectSettingsRoute: React.FC<SettingsTabProps> = observer(({ project }) => {
  useEffect(() => {
    uiStore.currentLocation = 'project.settings';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  return (
    <>
      <Header>Settings</Header>

      <ScreenContainer>
        <div className={styles['container']}>
          <ProjectSettingsForm project={project} />

          <DangerZone project={project} />
        </div>
      </ScreenContainer>
    </>
  );
});
